import { render, staticRenderFns } from "./BrandsCreateEdit.vue?vue&type=template&id=a9d5997e&scoped=true"
import script from "./BrandsCreateEdit.vue?vue&type=script&lang=js"
export * from "./BrandsCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./BrandsCreateEdit.vue?vue&type=style&index=0&id=a9d5997e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d5997e",
  null
  
)

export default component.exports